import React from 'react'
import {useForm} from "react-hook-form";
import {getMe, putUsers} from "../../../../redux/actions";
import {Button, Form, Header} from "semantic-ui-react";

export const User = ({item}) => {
    const {register, handleSubmit, formState} = useForm();

    const onSubmit = async data => {
        if(data.password.length === 0){
            delete data['password'];
        }

        try {
            await putUsers(data);
            const res = await getMe();

            sessionStorage.setItem('Data', JSON.stringify(res.data))
        } catch (e) {
            alert('error')
        }
    };

    return <React.Fragment>
        <Header textAlign={"center"}>
            Dados do Usuário
        </Header>
        <Form onSubmit={handleSubmit(onSubmit)} loading={formState.isSubmitting}>
            <input type={'hidden'} name={'id'} defaultValue={item.id} ref={register()}/>
            <Form.Field>
                <label>E-mail (deve ser o mesmo cadastrado no PagSeguro)</label>
                <input
                    name={'username'}
                    defaultValue={item.username}
                    ref={register({required: true})}
                />
            </Form.Field>
            <Form.Field>
                <label>Senha (Atual)</label>
                <input
                    name={'old'}
                    type={'password'}
                    defaultValue={''}
                    ref={register({required: true})}
                />
            </Form.Field>

            <Form.Field>
                <label>Nova senha</label>
                <input
                    name={'password'}
                    type={'password'}
                    defaultValue={''}
                    ref={register()}
                />
            </Form.Field>

            <Button
                fluid
                primary
                content={'Salvar'}
                disabled={formState.isSubmitting}
                loading={formState.isSubmitting}
            />
        </Form>
    </React.Fragment>
}